import { render, staticRenderFns } from "./ReceberPagamento.vue?vue&type=template&id=277fdfe2&"
import script from "./ReceberPagamento.vue?vue&type=script&lang=js&"
export * from "./ReceberPagamento.vue?vue&type=script&lang=js&"
import style0 from "./ReceberPagamento.vue?vue&type=style&index=0&id=277fdfe2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports